export const generateSearchResultsStyles = () => ({
    wrapper: {
        marginTop: '7vh',
    },
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
